import styled from '@emotion/styled';

export const CommandActionWrapper = styled.div<{ isReversed: boolean }>`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    flex-direction: ${(props) => props.isReversed ? 'row-reverse' : 'row'};
`;
